export default ({
  isFirstLoading: true,
  hideAttachPatientModel: false,
  formOrigin: null,
  promRequest: null,
  error: {
    done    : false,
    messages: []
  },
  avatar:{
    fileReference: null,
  },
  authors: [],
  configForm: {},
  imagesField: {},
  uploadedDocuments: {},
  activeJobs: {},
  jobStreams: {},
  fieldsSimilar: {},
  fetching: {
    getListFields: false,
    getModelById: false,
    saveVersionField: false,
    saveForm: false,
    getDraftById: false,
    saveDraft: false,
    saveNewAvatar: false,
    createAuthor: false,
    updateAuthor: false,
    getListAuthor: false,
  },
  listFields: {
    items: {},
    customIds: [],
    customIdsOriginal: []
  },
  fields: [],
  api: {
    getListFields: [],
  },
  dynamicForms: { //exemplo do objeto em assets/examples/dynamicForms.js
    draftId: '',
    fields: {},
    modules: {},
    sections: {},
    forms: {
      idForm: '',
      name: '',
      description: '',
      attachPatientModel: false,
      sectionsIds: [],
      authors: []
    }
  },
  modal: {
    editField: {
      modalId: 'editField',
      name: '',
      visible: false,
      field: {},
      table: {},
      optionsFields: {},
      columnsIds: [],
      rowsIds: [],
      onSave: () => {},
      onClose: () => {},
      onOpen: () => {}
    }
  }
});

//Exemplo basico das propriedades da modal
// const modal = ({
//   'idModal': {
//     modalId: 'idModal',
//     name: 'Titulo da Modal',
//     done: false,
//     fields: {
//       'idField': {
//         id: '',
//         name: '',
//         size: 0,
//         dataType: 1,
//         optionsFieldsIds: [],
//         columnsIds: [],
//         rowsIds: [],
//         tableId: ''
//       },
//     },
//     optionsFields: {
//       'idOptionField': {
//         //property option
//       }
//     },
//     tables: {
//       'idTable': {
//         id: '',
//         name: '',
//         columnsIds: [],
//         rowsIds: []
//       }
//     },
//     columnsIds: [],
//     rowsIds: [],
//     onSave: () => {},
//     onClose: () => {},
//     onOpen: () => {}
//   }
// });